import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { ArrowLeft, ArrowRight } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [debugUrl, setDebugUrl] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setMsg(""); setDebugUrl("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      if (data.debug_reset_url) {
        setDebugUrl(data.debug_reset_url);
        setMsg("Email integration not configured — use this link to reset your password:");
      } else {
        setMsg("If that email exists, a reset link has been sent. Check your inbox.");
      }
    } catch (e) {
      setMsg(e.response?.data?.detail || "Something went wrong.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-5 py-10 grain">
      <div className="relative z-10 w-full max-w-md crystal-glass rounded-3xl p-8 sm:p-10 animate-fade-up">
        <Link to="/login" className="inline-flex items-center gap-2 text-cream/60 hover:text-cream text-xs tracking-[0.2em] uppercase font-bold mb-4">
          <ArrowLeft size={14} /> Back to login
        </Link>
        <p className="text-papaya text-xs tracking-[0.3em] uppercase font-bold">Reset</p>
        <h1 className="text-cream text-4xl font-black tracking-tighter mt-1 leading-none">Forgot<br/>password?</h1>
        <p className="text-cream/60 mt-3 text-sm">Enter your email — we'll send a reset link.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <label className="block">
            <span className="text-cream/70 text-xs tracking-[0.2em] uppercase font-bold">Email</span>
            <input
              data-testid="forgot-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-white/5 border border-white/10 rounded-2xl px-4 py-3 text-cream placeholder:text-cream/30 focus:outline-none focus:border-papaya"
            />
          </label>
          <button
            data-testid="forgot-submit"
            type="submit"
            disabled={busy}
            className="w-full py-4 rounded-full bg-papaya text-ink font-black tracking-[0.2em] uppercase text-sm hover:bg-papaya-hover transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {busy ? "Sending…" : <>Send reset link <ArrowRight size={16} weight="bold" /></>}
          </button>
        </form>

        {msg && <p data-testid="forgot-msg" className="mt-5 text-sm text-cream/80">{msg}</p>}
        {debugUrl && (
          <a href={debugUrl} data-testid="forgot-debug-url" className="mt-2 block text-papaya text-xs break-all hover:underline">{debugUrl}</a>
        )}
      </div>
    </div>
  );
}
